<template>
    <div>
      <div style="margin-bottom: 1.5rem;" id='usagu' v-if='onlinestate == "pc"'>
        <span style="color: #09666E;font-size: 16px;">{{islang=='big5'?'選擇地區：':'Select Region: '}}</span>
         <a-select v-model='input' style="width: 10rem" @change='seachand'>
           <a-select-option v-for='(v,i) in list' :key='i+"2112"' :value="i">{{islang=='big5'?v.name:v.name_en}}</a-select-option>
         </a-select>
      </div>
      <div style="margin-bottom: 1.5rem;position: relative;" id='usagu' v-else>
        <span style="color: #000;font-size: 16px;position: absolute;z-index: 90;position: absolute;top: 6px;left: 5px;">{{islang=='big5'?'選擇地區':'Select Region'}}</span>
         <a-select v-model='input' style="width: 100%" @change='seachand' id='is_right'>
           <a-select-option v-for='(v,i) in list' :key='i+"2112"' :value="i">{{islang=='big5'?v.name:v.name_en}}</a-select-option>
         </a-select>
      </div>
    </div>
</template>

<script>
  export default{
    props:['seach'],
    data(){
      return{
        onlinestate:sessionStorage['onlinestate'],
        islang : window.localStorage.guanwanglang,
        list:[
          {name:'美股',url:'/usstock-intro',name_en:'US Stocks'},
          // {name:'滬港深通',url:'/shstock-intro',name_en:'Shanghai-HK Stocks'},
          {name:'新加坡股',url:'/sgstock-intro',name_en:'Singapore Stocks'},
          {name:'馬來西亞股',url:'/mystock-intro',name_en:'Malaysia Stocks'},
          {name:'澳洲股',url:'/austock-intro',name_en:'Australia Stocks'},
          {name:'日股',url:'/jpstock-intro',name_en:'Japan Stocks'},
          {name:'台股',url:'/twstock-intro',name_en:'Taiwan Stocks'},
          {name:'德股',url:'/destock-intro',name_en:this.$lang.d_g},
          ],
        input:0
      }
    },
    watch:{
      seach:{
        immediate:true,
        handler(ev){
          if(ev){
            this.list.map((val,ind)=>{
              if(val.name==this.seach){
                 this.input= ind
              }
            })
          }
        }
      }
    },
    methods:{
      seachand(ev){
        this.list.map((val,i)=>{
          if(i == this.input){
            this.$router.push(val.url)
          }
        })
      }
    }
  }
</script>

<style>
  #usagu .ant-select-selection--single {
      /* height: 2rem; */
      border-radius: 0;
      border-color: #333;
      font-size: 16px;
      }
   #usagu .ant-select-selection__rendered{
      /* line-height: 2rem; */
    }
    #is_right .ant-select-selection-selected-value {
        float: right;
        position: relative;
        right: 5px;
    }

    #usagu .ant-select-focused .ant-select-selection, .ant-select-selection:active, .ant-select-selection:focus {
        -webkit-box-shadow: 0 0 0 0 #000;
        box-shadow: 0 0 0 0 #000;
    }
</style>



// WEBPACK FOOTER //
// src/components/login/seachlange.vue